export default {
    'login.form.system.title': 'Login to CMIC ENRIC',
    'login.form.system.subtitle': 'CMIC ENRIC',
    'login.form.title': 'Login to Zhong Ji An Rui Ke',
    'login.form.userName.errMsg': 'Username cannot be empty',
    'login.form.password.errMsg': 'Password cannot be empty',
    'login.form.login.errMsg': 'Login error, refresh and try again',
    'login.form.login.success': 'welcome to use',
    'login.form.userName.placeholder': 'Username: admin',
    'login.form.password.placeholder': 'Password: admin',
    'login.form.rememberPassword': 'Remember password',
    'login.form.forgetPassword': 'Forgot password',
    'login.form.login': 'login',
};
